import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

import { PET_TYPE } from "../../store/variables";

import { ProductGroup } from "../../classes/productGroup";
import { PetType } from "../../classes/petType";

interface Props {
  petName: string;
  liability: boolean;
  productGroup: ProductGroup;
  selectedPetType: PetType;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HeadlineComponent',
  props: {
    petName: {},
    liability: { type: Boolean, default: false },
    productGroup: { default: undefined },
    selectedPetType: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["quote-name", { liability: props.liability }])
  }, [
    (props.petName)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (props.liability)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", null, " Möchten Sie " + _toDisplayString(props.petName) + " auch gleich Haftpflicht versichern? ", 1),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "liability-circle" }, [
                  _createElementVNode("span", null, "50% sparen")
                ], -1))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(props.productGroup.name) + "-Tarife für " + _toDisplayString(props.petName), 1)
              ], 64))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(" Tarife " + _toDisplayString(props.productGroup.name) + " für " + _toDisplayString(props.selectedPetType.id === _unref(PET_TYPE).DOG ? "Hunde" : "Katzen") + " im Vergleich ", 1)
        ], 64))
  ], 2))
}
}

})